import React, { useState } from "react";
const MAX_FILE_SIZE = 1.25 * 1200 * 350; // 1MB
const MAX_WIDTH = 1200;
const MAX_HEIGHT = 350;
const SlideFrom = ({ onSubmit, onCancel }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const selected = e.target.files[0];
    setError(""); // clear previous error

    if (selected) {
          if (selected.size >= MAX_FILE_SIZE) {
        setError("File size should be less than 1MB.");
        return;
      }

      const img = new Image();
      const objectUrl = URL.createObjectURL(selected);
      img.src = objectUrl;

      img.onload = () => {
        if (img.width > MAX_WIDTH || img.height > MAX_HEIGHT) {
          setError(
            `Image dimensions should not exceed ${MAX_WIDTH}x${MAX_HEIGHT}px.`
          );
          URL.revokeObjectURL(objectUrl);
          return;
        }

        setFile(selected);
        setPreview(objectUrl);
      };
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (file) {
      onSubmit(file);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <section className="content container-fluid mt-4">
        <div className="row">
          <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
            <div className="box box-primary">
              <div className="box-header with-border d-flex justify-content-between align-items-center"></div>
              <h3>{"Upload Image"}</h3>

              <div className="mb-3">
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={handleChange}
                />
              </div>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              {preview && (
                <div className="mb-3 text-center">
                  <img
                    src={preview}
                    alt="Preview"
                    className="img-thumbnail"
                    style={{ maxWidth: "300px", maxHeight: "200px" }}
                  />
                </div>
              )}

              <div className="d-flex gap-2">
                <button type="submit" className="btn btn-primary">
                  {"Upload"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </form>
  );
};

export default SlideFrom;
